export const LOGIN_PATH = '/login';
export const BASE_PATH = '/';
export const ALCOHOL_PATH = '/alcohol';
export const ATTANDANCE_PATH = '/attendance';
export const DRIVER_PATH = '/driver';
export const VEHICLE_PATH = '/vehicle';
export const VEHICLE_ID_PATH = '/vehicle/:id';
export const VEHICLE_USER_ID_PATH = '/vehicle/user/:id';
export const DEVICE_PATH = '/device';
export const CLIENT_PATH = '/client';
export const CLIENT_PATH_ADD = '/client/add';
export const CLIENT_ID_PATH_EDIT = '/client/:id/edit';
export const CLIENT_ID_PATH_VIEW = '/client/:id/view';
export const Driver_ID_PATH = '/driver/:id';
export const DRIVER_HEALTHCHECK_DETAIL = '/driver/healthcheck/:id';
// EV-116 段階2B。会社の設定（時間帯）。
export const SETTINGS_COMPANY_PATH = '/settings/company';
// YAC-2026-009 PR5a。運営の画面（会社をまたぐ。自社の画面とは分ける）。
export const OPERATOR_PATH = '/operator';
// YAC-2026-009 PR5b。運営の画面（会社・会社ごとの管理者・運営）。
export const OPERATOR_COMPANIES_PATH = '/operator/companies';
export const OPERATOR_COMPANY_NEW_PATH = '/operator/companies/new';
export const OPERATOR_COMPANY_PATH = '/operator/companies/:id';
export const OPERATOR_OPERATORS_PATH = '/operator/operators';
export const operatorCompanyPath = (id: number | string) => `/operator/companies/${id}`;

/**
 * ログインの後に開く画面。管理者の役割があれば自社の画面（今までどおり）、運営だけなら運営の画面。
 * 両方を持つアカウントは自社の画面を開き、メニューから運営の画面へ行く。
 */
export function homePathFor(roles: readonly string[] | null): string {
  if (roles && roles.includes('manager')) return BASE_PATH;
  if (roles && roles.includes('operator')) return OPERATOR_PATH;
  return BASE_PATH;
}

// YAC-2026-009 PR7b。運営のサポート。
// サポートが終わった（401 support_access_ended）ときの画面（認証ガードの外。Cookie だけで運営の画面に戻れる）。
export const SUPPORT_ENDED_PATH = '/support/ended';
// 運営の画面の、サポートの一覧（どの会社・どの運営のものも）。
export const OPERATOR_SUPPORT_PATH = '/operator/support';
